export default "__VITE_ASSET__BVuC9$mq__"